export class UserInfo {
    showEmail = false;
    organization?: string;
    occupation?: string;
    phoneNumber?: string;
    website?: string;
    country?: string;
    city?: string;
    description?: string;
    picture?: string;
    headerImage?: string;
    title?: string;
    email?: string;

    get isAdmin(): boolean {
        let isAdmin: boolean = false;
        if (this.roles && this.roles.length > 0) {
            isAdmin = this.roles.indexOf('ContentAdmin') > -1;
        }
        return isAdmin;
    }

    constructor(
        public id: string,
        public firstName: string,
        public lastName: string,
        public userName?: string,
        public language?: string,
        public sessionId?: string,
        public nbf?: number,
        public exp?: number,
        public sub?: string,
        public roles?: string[],
    ) {}
}
